import axios, { AxiosResponse } from 'axios'
import { Dispatch } from '@reduxjs/toolkit'

let detectedMarketHome: Promise<AxiosResponse> | null = null

// Kicked off from the client entry so the request races hydration; the
// HomePage dispatch below reuses the same in-flight promise.
export const prefetchDetectedMarketHome = () => {
  if (!detectedMarketHome) {
    const request = axios.get('/detected_market_home')
    detectedMarketHome = request
    // Forget a failed request so a later mount retries; the promise
    // middleware consumes the rejection via the dispatch below.
    request.catch(() => {
      if (detectedMarketHome === request) {
        detectedMarketHome = null
      }
    })
  }

  return detectedMarketHome
}

export const fetchDetectedMarketHome = () => {
  return (dispatch: Dispatch) =>
    dispatch({
      type: 'HOME_DETECTED_MARKET_FETCH',
      payload: prefetchDetectedMarketHome(),
    })
}
